(() => {
  const requests = new WeakMap();
  const initialized = new WeakSet();
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  function keepRingSize(info, size) {
    if (!size) return;
    info.querySelectorAll('[data-iglam-legacy-picker="stacked-ring"] a[data-size-variants]').forEach((link) => {
      const pair = link.dataset.sizeVariants.split(',').map((entry) => entry.split(':')).find(([value]) => value === size);
      if (!pair) return;
      const url = new URL(link.href);
      url.searchParams.set('variant', pair[1]);
      link.href = url.href;
    });
  }

  function initialize(info) {
    if (initialized.has(info)) return;
    const picker = info.querySelector('[data-iglam-legacy-picker]');
    const home = info.querySelector('[data-iglam-legacy-home]');
    const mobile = info.querySelector('[data-iglam-mobile-colours]');
    if (!picker || !home) return;
    initialized.add(info);
    const place = () => {
      if (!info.isConnected) { mobileQuery.removeEventListener('change', place); return; }
      const destination = mobile && mobileQuery.matches ? mobile : home;
      if (picker.parentElement !== destination) destination.append(picker);
    };
    mobileQuery.addEventListener('change', place);
    place();
    info.addEventListener('change', (event) => {
      if (event.target.matches('variant-selects input[type="radio"], variant-selects select')) {
        keepRingSize(info, event.target.value);
      }
    });
  }

  function scan(root) {
    if (root.matches?.('product-info[data-iglam-legacy-family]')) initialize(root);
    root.querySelectorAll?.('product-info[data-iglam-legacy-family]').forEach(initialize);
  }
  scan(document);
  document.addEventListener('product-info:loaded', (event) => scan(event.target));
  new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) scan(node);
  }))).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('.iglam-legacy-card-swatch');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const card = link.closest('.card-main');
    const group = link.closest('[data-iglam-legacy-card]');
    if (!card || !group) return;
    event.preventDefault();
    requests.get(card)?.abort();
    const controller = new AbortController();
    requests.set(card, controller);
    group.setAttribute('aria-busy', 'true');
    const status = group.querySelector('.iglam-card-swatches__status');
    status.textContent = 'Loading ' + link.dataset.iglamLegacyColour;
    try {
      // Read the current native page so price, availability and cart identity stay authoritative.
      const response = await fetch(link.href, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Product unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const product = html.querySelector('product-info[id^="MainProduct"]');
      const variant = product?.querySelector('form[action*="/cart/add"] input[name="id"]');
      const purchase = product?.querySelector('form[action*="/cart/add"] button[name="add"]');
      const price = product?.querySelector('[id^="price-"] .price');
      const title = product?.querySelector('h1');
      const photos = product?.querySelectorAll('.product__media-list img');
      if (!product || product.dataset.productId !== link.dataset.productId || !variant?.value || !purchase || !price || !title || !photos?.length) {
        throw new Error('Incomplete product response');
      }
      if (requests.get(card) !== controller || !card.isConnected) return;
      const image = card.querySelector('.card--image > .featured-media');
      if (image) {
        image.removeAttribute('srcset');
        image.src = photos[0].getAttribute('src');
        image.alt = photos[0].alt || title.textContent.trim();
        image.loading = 'eager';
      }
      const secondary = card.querySelector('.card-secondary-image');
      if (secondary) {
        const secondaryImage = secondary.querySelector('img');
        if (photos[1] && secondaryImage) {
          secondaryImage.removeAttribute('srcset');
          secondaryImage.src = photos[1].getAttribute('src');
          secondaryImage.alt = photos[1].alt;
          secondary.style.removeProperty('display');
        } else secondary.style.display = 'none';
      }
      card.querySelectorAll('.card--image, .card-title a, [data-iglam-legacy-choose]').forEach((target) => { target.href = link.href; });
      const cardTitle = card.querySelector('.card-title a');
      cardTitle.textContent = group.dataset.familyTitle || cardTitle.textContent.trim();
      card.querySelector('.card-body-information > .price')?.replaceWith(price.cloneNode(true));
      card.querySelectorAll('.quick-add input[name="id"]').forEach((input) => {
        input.value = variant.value;
        input.disabled = purchase.disabled;
      });
      card.querySelectorAll('.quick-add input[name="product-id"]').forEach((input) => { input.value = product.dataset.productId; });
      card.querySelectorAll('.quick-add button[name="add"]').forEach((button) => {
        button.disabled = purchase.disabled;
        const label = button.querySelector('span:not(.sold-out-message)');
        if (label) label.textContent = purchase.querySelector('span')?.textContent.trim() || (purchase.disabled ? 'Sold out' : 'Add cart');
      });
      card.querySelectorAll('[data-product-url]').forEach((button) => { button.dataset.productUrl = link.href; });
      card.querySelectorAll('[data-product-handle]:not([data-iglam-legacy-colour])').forEach((button) => {
        button.dataset.productHandle = link.dataset.productHandle;
        button.classList.remove('added');
        button.setAttribute('aria-pressed', 'false');
      });
      card.querySelectorAll('[data-product_handle]').forEach((button) => { button.dataset.product_handle = link.dataset.productHandle; });
      const badge = card.querySelector('.card__badge');
      if (badge) {
        badge.replaceChildren();
        if (purchase.disabled) {
          const soldOut = document.createElement('span');
          soldOut.className = 'badge badge--bottom-left text-bg-danger';
          soldOut.textContent = 'Sold out';
          badge.append(soldOut);
        }
      }
      group.querySelectorAll('.iglam-legacy-card-swatch').forEach((swatch) => {
        if (swatch === link) swatch.setAttribute('aria-current', 'page');
        else swatch.removeAttribute('aria-current');
      });
      const more = group.querySelector('.iglam-card-swatches__more');
      if (more) more.href = link.href;
      group.dataset.selectedProduct = product.dataset.productId;
      status.textContent = link.dataset.iglamLegacyColour + ' selected';
    } catch (error) {
      if (error.name !== 'AbortError' && requests.get(card) === controller) window.location.assign(link.href);
    } finally {
      if (requests.get(card) === controller) group.removeAttribute('aria-busy');
    }
  });
})();
